import axios from "axios";

export const verifyEmailCode = async (email: string, code: string) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/email-verification/verify-code`, {
      email: email,
      code: code,
    });

    return {
      success: res.data.success,
      message: "인증이 완료되었습니다.",
      emailVerificationToken: res.data.emailVerificationToken,
    };
  } catch (error: any) {
    const statusCode = error.response.status;
    if (statusCode === 401) {
      return { success: false, message: "올바르지 않은 인증번호입니다. 번호를 확인해 주세요." };
    } else if (statusCode === 404) {
      return { success: false, message: "존재하지 않은 이메일입니다." };
    } else if (statusCode === 410) {
      return { success: false, message: "인증 시간이 만료되었습니다. 인증을 재요청 해주세요." };
    }
  }
};

export const sendEmailVerificatoin = async (email: string) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/email-verification/send-code/sign-up`, {
      email: email,
    });

    return { success: res.data.result, statusCode: 200, message: "" };
  } catch (error: any) {
    const statusCode = error.response.status;
    if (statusCode === 400) {
      return { success: false, statusCode: statusCode, message: "유효한 이메일이 아닙니다. 이메일을 확인해주세요." };
    } else if (statusCode === 409) {
      return { success: false, statusCode: statusCode, message: "이미 가입된 이메일입니다. 로그인을 진행해 주세요." };
    } else if (statusCode === 500) {
      return { success: false, statusCode: statusCode, message: "다시 시도해주세요." };
    }
  }
};

export const sendEmailVerificatoinByForgotPassword = async (
  email: string
): Promise<{ success: boolean; statusCode: number; message: string }> => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/email-verification/send-code/forgot-password`, {
      email: email,
    });

    return { success: res.data.result, statusCode: 200, message: res.data.message };
  } catch (error: any) {
    const statusCode = error.response.status;
    return { success: false, statusCode: statusCode, message: "" };
  }
};
